var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSii(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 125,
    viewBox: "0 0 89 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.167 1H3.36302C2.05796 1 1 3.02097 1 5.51397V119.486C1 121.979 2.05796 124 3.36302 124H86.167C87.472 124 88.53 121.979 88.53 119.486V5.51397C88.53 3.02097 87.472 1 86.167 1Z",
    stroke: "#733FE7",
    strokeWidth: 0.901897,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9894 10.5283H78.2975C79.3583 10.5283 80.2183 12.2362 80.2183 14.3429V110.657C80.2183 112.764 79.3583 114.472 78.2975 114.472H10.9894C9.9286 114.472 9.06863 112.764 9.06863 110.657V14.3429C9.06863 12.2362 9.9286 10.5283 10.9894 10.5283Z",
    stroke: "#733FE7",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6045 51.2393H49.4115",
    stroke: "#733FE7",
    strokeWidth: 2.48022,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6045 60.7676H49.4115",
    stroke: "#733FE7",
    strokeWidth: 2.48022,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6045 69.4297H49.4115",
    stroke: "#733FE7",
    strokeWidth: 2.48022,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5459 51.2393L69.9494 51.2393",
    stroke: "#733FE7",
    strokeWidth: 2.48022,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5459 60.7676H69.9494",
    stroke: "#733FE7",
    strokeWidth: 2.48022,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5459 69.4297H69.9494",
    stroke: "#733FE7",
    strokeWidth: 2.48022,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5459 82.4219H69.9494",
    stroke: "#733FE7",
    strokeWidth: 2.48022,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6045 100.612L69.9496 100.612",
    stroke: "#733FE7",
    strokeWidth: 2.48022,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6045 33.0498L69.9496 33.0498",
    stroke: "#733FE7",
    strokeWidth: 2.48022,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0737 26.1201L58.2133 26.1201",
    stroke: "#733FE7",
    strokeWidth: 2.48022,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSii);
export default __webpack_public_path__ + "static/media/sii.942a9988.svg";
export { ForwardRef as ReactComponent };